import React from 'react';
import { styled } from '@mui/material/styles';
import { SvgIcon } from '@mui/material';

const StyledProgressIcon = styled(SvgIcon)(() => ({
  animation: 'spin 1.5s linear infinite',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

const AnimatedProgressIcon = (props) => {
  return (
    <StyledProgressIcon {...props} viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="31.416"
        strokeDashoffset="7.854"
        opacity="0.3"
      />
      <circle
        cx="12"
        cy="12"
        r="10"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="15.708"
        strokeDashoffset="0"
        transform="rotate(-90 12 12)"
      />
    </StyledProgressIcon>
  );
};

export default AnimatedProgressIcon;

